import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '../../store/auth';

const API_URL = import.meta.env.VITE_API_URL || '';

export default function Municipalities() {
    const { provinceId } = useParams();
    const { token } = useAuthStore();
    const queryClient = useQueryClient();
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ name: '', slug: '', displayName: '' });

    const { data: municipalities, isLoading } = useQuery({
        queryKey: ['municipalities', provinceId],
        queryFn: async () => {
            const res = await fetch(`${API_URL}/admin/provinces/${provinceId}/municipalities`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.json();
        }
    });

    const createMutation = useMutation({
        mutationFn: async () => {
            const res = await fetch(`${API_URL}/admin/provinces/${provinceId}/municipalities`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    name: formData.name,
                    slug: formData.slug,
                    display_name: formData.displayName
                })
            });
            return res.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['municipalities', provinceId] });
            setShowForm(false);
        }
    });

    return (
        <div>
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2>🏛️ Municipios</h2>
                <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
                    + Nuevo Municipio
                </button>
            </div>

            {showForm && (
                <div className="card" style={{ marginBottom: '1rem' }}>
                    <h3>Crear Municipio</h3>
                    <div className="form-group">
                        <label className="form-label">Nombre</label>
                        <input
                            className="form-input"
                            value={formData.name}
                            onChange={(e) => setFormData({
                                ...formData,
                                name: e.target.value,
                                slug: e.target.value.toLowerCase().replace(/\s+/g, '-'),
                                displayName: `Municipalidad de ${e.target.value}`
                            })}
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Nombre para Mostrar</label>
                        <input
                            className="form-input"
                            value={formData.displayName}
                            onChange={(e) => setFormData({ ...formData, displayName: e.target.value })}
                        />
                    </div>
                    <button className="btn btn-primary" onClick={() => createMutation.mutate()}>
                        Crear
                    </button>
                </div>
            )}

            <div className="card">
                {isLoading ? <p>Cargando...</p> : (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Bot Name</th>
                                <th>Módulos</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {municipalities?.map((m: any) => (
                                <tr key={m.id}>
                                    <td>{m.display_name}</td>
                                    <td><code>{m.bot_name}</code></td>
                                    <td>{m.enabled_modules?.join(', ')}</td>
                                    <td>
                                        <span className={`badge ${m.enabled ? 'badge-success' : 'badge-warning'}`}>
                                            {m.enabled ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td>
                                    <td style={{ display: 'flex', gap: '5px' }}>
                                        <a href={`/municipalities/${m.id}/branding`} className="btn btn-sm btn-outline">
                                            🎨 Branding
                                        </a>
                                        <a href={`/municipalities/${m.id}/config`} className="btn btn-sm btn-outline">
                                            ⚙️ Config
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
